import { render } from "./WorkslopCrisis.vue?vue&type=template&id=6b1d1a6f"
import script from "./WorkslopCrisis.vue?vue&type=script&lang=js"
export * from "./WorkslopCrisis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__